module.exports = __webpack_public_path__ + "media/landing_page_phone_gradient.f2c7d7f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing_page_phone_gradient.png
// module id = ./src/assets/landing_page_phone_gradient.png
// module chunks = 0